// @flow

import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';

type HeadingsType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

type Props = {|
  children: React$Node,
  className?: '',
  color?: 'light' | 'dark',
|};

const createHeading = (type: HeadingsType) => ({
  children, className = '', color = 'light', ...rest
}: Props) => {
  const hProps = {
    className: classnames(
      styles[type],
      styles[color],
      className,
    ),
    children,
    ...rest,
  };
  return React.createElement(type, hProps, children);
};

export const H1 = createHeading('h1');
export const H2 = createHeading('h2');
export const H3 = createHeading('h3');
export const H4 = createHeading('h4');
export const H5 = createHeading('h5');
export const H6 = createHeading('h6');
